import { STRIIVE_JOB_STATUS_LABELS, StriiveJobStatusesEnum } from 'consts/jobs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';
import { formatDateUS } from '@libs/ui/components/job/utils';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface JobInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const JobInfoAccordion: React.FC<JobInfoAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('job');

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  console.log('🚀 ~ JobInfoAccordion ~ striive_job:', striive_job);
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : '-';

  const formatNumber = (num: any) =>
    typeof num === 'number'
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : '-';

  const mappedData = {
    recordType: striive_job
      ? getValue(striive_job.order_classification_type)
      : '-',
    jobStage: striive_job
      ? getValue(striive_job.order_classification_status)
      : '-',
    positionType: striive_job ? getValue(striive_job.job_type) : '-',
    status: striive_job?.status
      ? STRIIVE_JOB_STATUS_LABELS[
          striive_job.status as StriiveJobStatusesEnum
        ] || '-'
      : '-',
    currency: getValue(striive_job?.rate_type) || 'USD - U.S. Dollar',
    startTime: striive_job ? formatDateUS(striive_job.start_date) : '-',
    endTime: striive_job ? formatDateUS(striive_job.end_date) : '-',
    rateCard: striive_job ? getValue(striive_job.record_id) : '-',
    revenue: striive_job
      ? formatNumber(striive_job.estimated_additional_spend)
      : '-',
  };
  console.log('🚀 ~ JobInfoAccordion ~ mappedData:', mappedData);

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title={t('v2.accordion.jobInfo')} expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem(t('v2.accordion.recordType'), mappedData.recordType)}
        {renderDetailItem(t('v2.accordion.jobStage'), mappedData.jobStage)}
        {renderDetailItem(t('v2.accordion.positionType'), mappedData.positionType)}
        {renderDetailItem(t('v2.accordion.status'), mappedData.status)}
        {renderDetailItem(t('v2.accordion.currency'), mappedData.currency)}
        {renderDetailItem(t('v2.accordion.startTime'), mappedData.startTime)}
        {renderDetailItem(t('v2.accordion.endTime'), mappedData.endTime)}
        {renderDetailItem(t('v2.accordion.rateCard'), mappedData.rateCard)}
        {renderDetailItem(t('v2.accordion.revenue'), mappedData.revenue)}
      </Grid>
    </JobAccordion>
  );
};
